import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=0ecef032&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=0ecef032&prod&scoped=true&lang=css"
import style1 from "./Update.vue?vue&type=style&index=1&id=0ecef032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecef032",
  null
  
)

export default component.exports